export const focusableElementSelectors = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])', 
    'textarea:not([disabled])', 
    'button:not([disabled])', 
    'iframe',
    'object', 
    'embed', 
    '*[tabindex]', 
    '*[contenteditable]'
];

export default function($el) {
    if(!$el) {
        return null;
    }
    
    if($el?.nodeType === Node.ELEMENT_NODE) {
        $el = $($el);
    }

    const selectorStr = focusableElementSelectors.join(',');
    const $focusable = $el.find(selectorStr);
    const $visible = $focusable.filter(index => $focusable.eq(index).is(':visible'));
    return $visible;
}
